import React, { useEffect, useState, useRef } from "react";
import styles from "./scss/chatInner.module.scss";
import ChatEmpty from "../chatWidgets/chatEmpty";
import ChatTextMessage from "../chatWidgets/textMessage";
import { Divider } from "antd";
import ChatFilesMessage from "../chatWidgets/chatFiles";
import URBroadcastMessage from "../chatWidgets/broadCastMessage";
import ChatTaskMessage from "../chatWidgets/taskMessage";
import URChatEventsMessage from "../chatWidgets/eventsMessage";
import ChatNotesMessage from "../chatWidgets/notesMessage";
import ChatReplyMessage from "../chatWidgets/chatReply";
import ChatDeletedMessage from "../chatWidgets/chatDeleted";
import { chats, chatwindowDetails, initialStateModel } from "../../../models/model";
import { useSelector } from "react-redux";
import { getGroupDateFormat, gifFormat, strickerFormat } from "../../../base/utils";
import ChatMentionMessage from "../chatWidgets/atMention";
import Lottie from "lottie-react";
import ContactLoader from "../../../styles/images/centerGreen.json";
import moment from "moment";
import _ from "lodash";
import { userInfo } from "../../../base/socketChatService/utils";
import ChatMapLocation from "../chatWidgets/location";
import ChatGifMessage from "../chatWidgets/chatGif";
import CloudImageDis from "../chatWidgets/chatFiles/cloudfilesDisplay";
import store from "../../../context/store/store";
import { Types } from "../../../context/action/action";

 function ChatInnerFrame() {
  const chatWindow: chats = useSelector((state: initialStateModel) => state.chatReducer);
  const chatWindowDetailReducer: chatwindowDetails = useSelector((state: initialStateModel) => state.chatWindowReducer);
  let {isNewMessageWindow, newUserMembers, chatWindowDetails,newTagMessage } = chatWindowDetailReducer;
  const chatSocketMessage = useSelector((state: initialStateModel) => state.chatSocketReducerState);
  let {scrollUnread}:any=store.getState().chatReducer;
  //const { typingStart, typingContactName ,msgType}: typingReducerModel = useSelector((state: initialStateModel) => state.typingReducerState);
  const [mount,setMount] = useState<boolean>(false);
  const  mesgLength = useRef(0);
  const internetReducer = useSelector((state:any)=>state.internetReducer);

  const gotoBottom = (id: string, scrollPos?:any) => {
  
    var element: HTMLElement | any = document.getElementById(id) || null;
    if (element != null) {
      let heightScroll = element.scrollHeight;
      element.scrollTop = scrollPos? -scrollPos:heightScroll;
    }
  };

  useEffect(() => {
    if(chatSocketMessage.archiveID==="")
    {
      if(chatSocketMessage?.messageList?.[chatSocketMessage.messageList.length-1]?.direction==="IN"){
        
      } else {
        if(mesgLength.current!==chatSocketMessage?.messageList.length){
          gotoBottom("chatWindow");
        }
      }
      mesgLength.current = chatSocketMessage?.messageList.length;
    }
    else if(chatSocketMessage.archiveID &&chatSocketMessage.scrollPos>-1){
      if(chatSocketMessage?.messageList?.[chatSocketMessage.messageList.length-1]?.direction==="IN"){

      } else {
        if(mesgLength.current!==chatSocketMessage?.messageList.length){
          gotoBottom("chatWindow",chatSocketMessage.scrollPos);
        }
      }
      mesgLength.current = chatSocketMessage?.messageList.length;
    }
    if(chatSocketMessage.messageList.length===0 && !chatSocketMessage.archiveID){
      setMount(false);
      console.log(mount)
    }

  }, [JSON.stringify(chatSocketMessage.messageList)]);

  const timeDifference = (date1:number,date2:number) => {
    const absValue = Math.abs(date2 - date1) / (1000 * 60);
    var difference = parseInt(absValue.toString());
    return difference > 15 ? false:true;
  }

  const fileTypeeDifference = (type1:any,type2:any) => {
    let filDiff:boolean = false; 
    if(type2?.message?.messageType === type1?.message?.messageType){
      let msg = _.isObject(type1.message.body) ?  type1.message.body : type1.message.body;
      let msg2 = _.isObject(type2.message.body) ?  type2.message.body : type2.message.body;
      if(gifFormat.indexOf(msg2?.fileType) === gifFormat.indexOf(msg?.fileType) && strickerFormat.indexOf(msg2?.fileType) === strickerFormat.indexOf(msg?.fileType) ){
        filDiff = true;
      } else {
        filDiff = false;
      }
    }
    return filDiff;
  };
 
  // let groupedArray = groupbyday(archiveMessageArray);
  let searchedData = chatWindow.searchData;
  // let searchedData = chatWindow.isSaveChat?
  // chatWindow.saveChatData:
  // fileopenWindow.isviewContactFile&&fileopenWindow.contactFileData;
  let result:any = _(chatSocketMessage.messageList).filter((message:any)=>{
    const userDetailsnew = userInfo();
    const currUser = parseInt(userDetailsnew.fromID);
    const recentID = parseInt(message.from) !== currUser ? message.from : parseInt(message.to) !== currUser ? message.to : "";
    const mesgType = message?.type===1 ?  recentID: message.chatId;
    if(message?.type ===1){
      return mesgType?.toString()===chatWindowDetails?.sip_login_id?.toString() || currUser===parseInt(message?.to);
    } else {
      return mesgType?.toString()===chatWindowDetails?.team_id?.toString();
    }
  })
  .groupBy((o:any) => (o.timestamp && 
   moment(o.timestamp).format('DD MMM YYYY')))
  .map((contacts:any, letter:any) => ({ letter, contacts })).reverse()
  .value();
  let savedData = chatWindow.isSaveChat?chatWindow?.saveChatData?.id:"";
  //let letter ='';
  let groupmessage: Array<any>=[];
  let lastArray:Array<any> = [];
  let lastReplyArray:Array<any> = [];
  let replyArray:Array<any> = [];
  let timeGroup: Array<any>=[];
  let lasttimeGroup: Array<any>=[];
  let unreadmsgcount = newTagMessage.length>1? "unread messages":"unread message";
  return (
    <>
      {chatSocketMessage.messageLoading &&  !chatSocketMessage.archiveID && internetReducer.internet===false && <Lottie loop={true} width={300} className={`${styles.delayLoader} svgLoading`}
        animationData={ContactLoader} />}

  { Array.isArray(result) && result.length>0 && result.map((elem: any, index: any) => {
           if(elem.letter === "false") return null;
            return (
              <>
              <div className="innermessages" id={index}>
                  <div className="dividercross topset"><div className="dividerLineView">{getGroupDateFormat(elem.letter)}</div></div>
      {elem.contacts.map((msgList: any, index: any,array:any) => {
         let nextMessage  = (elem.contacts.length-1!==index)?elem.contacts[index+1]:-1;

         if((index===elem.contacts.length-1)){
          lasttimeGroup = lasttimeGroup.concat(timeGroup);
          timeGroup = [];
            } 
            let broad = nextMessage?.message?.messageType === 'BROADCAST' && msgList?.message?.messageType !== 'BROADCAST'
            
            if(msgList.direction===nextMessage?.direction && nextMessage?.from===msgList?.from 
              &&  timeDifference(nextMessage.timestamp,msgList.timestamp) && !broad ){
                timeGroup.push(msgList);
            }else if(nextMessage!==-1 && msgList.direction===nextMessage?.direction && nextMessage?.from===msgList?.from
             && timeDifference(nextMessage.timestamp,msgList.timestamp)&& !broad){
                timeGroup.push(msgList);
                lasttimeGroup = lasttimeGroup.concat(timeGroup);
                timeGroup = [];
            }else if(nextMessage!==-1 && msgList.direction!==nextMessage?.direction && !broad){
              timeGroup.push(msgList);
              lasttimeGroup = lasttimeGroup.concat(timeGroup);
              timeGroup = [];
            }else if(nextMessage===-1 && !broad){
              timeGroup.push(msgList);
              lasttimeGroup =lasttimeGroup.concat(timeGroup);
              timeGroup = [];
            } else {
              timeGroup.push(msgList);
              lasttimeGroup =lasttimeGroup.concat(timeGroup);
              timeGroup = [];
            }    
            if(Array.isArray(lasttimeGroup) && lasttimeGroup.length>0){
              let secondTimeArray:any = [];
              secondTimeArray= lasttimeGroup;
              lasttimeGroup = [];
            
              return (
                <>
                <div className= {secondTimeArray.length>1 ?"ifGrouped":"single"}> 
      {secondTimeArray && secondTimeArray.map((msgList: any, index: any) => {
      let messageBody = msgList?.message;
      let nextMessage  = (secondTimeArray.length-1!==index)?secondTimeArray[index+1]:-1;
      if((index===secondTimeArray.length-1)||(nextMessage!==-1&& messageBody?.messageType!==nextMessage?.message?.messageType)){
      lastArray = lastArray.concat(groupmessage);
      groupmessage = [];
      } 
      if((index===secondTimeArray.length-1)||(nextMessage!==-1&& messageBody?.threadId !== nextMessage?.message?.threadId)){
        lastReplyArray = lastReplyArray.concat(replyArray);
        replyArray = [];
      } 
      // try{
      if((messageBody?.messageType === "FILE") && !messageBody?.body?.isCloudfiles 
      && ((!messageBody?.isReply) && (_.isUndefined(messageBody?.isDelete)===true))) {
        let secondArray:any = [];
        secondArray.push(msgList);
        //const absValue1 = nextMessage?.timestamp !== undefined && msgList.direction===nextMessage?.direction ?Math.abs(nextMessage?.timestamp - msgList?.timestamp) / (1000 * 60): 16;
        return(<> {newTagMessage?.length >0 && (newTagMessage[0]?.id === msgList?.id) &&  <div className="dividercross"><div className="dividerLineView">{newTagMessage.length>0?newTagMessage.length:''} {unreadmsgcount}</div></div>}
        <ChatFilesMessage key={index} groupdata={secondArray} searchedData={searchedData}
          data={secondArray}  savedData={savedData} timeValue={index === 0 ? 18:1}/></>)
      } 
      else if(( messageBody?.messageType === "IMAGE" ) && !messageBody?.body?.isCloudfiles 
      && ((_.isUndefined(messageBody?.isDelete)===true))) {
        try{

        if((gifFormat.indexOf(messageBody?.body.fileType) !== -1) &&(!messageBody?.isReply)){
          let secondArray:any = [];
          secondArray.push(msgList);
          return(<> {newTagMessage?.length >0 && (newTagMessage[0]?.id === msgList?.id) && <div className="dividercross"><div className="dividerLineView">{newTagMessage.length>0?newTagMessage.length:''} {unreadmsgcount}</div></div>}
          <ChatGifMessage key={index} multiData={secondArray} searchedData={searchedData}
            data={secondArray}  savedData={savedData} timeValue={index === 0 ? 18:1}/></>)
        }
        let atest = ((messageBody?.replyMsgBody?.id === nextMessage?.message?.replyMsgBody?.id))
        let btext = (nextMessage?.message?.isReply ? "t" : nextMessage?.message?.body?.text==="")
        let bbtext = (messageBody?.isReply ? "t" : messageBody?.body?.text==="")
        if(messageBody?.messageType===nextMessage?.message?.messageType  && atest
        && msgList.direction===nextMessage?.direction && nextMessage?.from===msgList?.from 
        &&gifFormat.indexOf(messageBody?.body.fileType) === -1&&  btext  && bbtext && timeDifference(nextMessage.timestamp,msgList.timestamp) && fileTypeeDifference(nextMessage,msgList)){
          msgList["indexValue"] = index;
          groupmessage.push(msgList);
         
      } else if(nextMessage!==-1 && messageBody?.messageType!==nextMessage?.message?.messageType  && atest
        && msgList.direction===nextMessage?.direction && nextMessage?.from===msgList?.from
        && btext  && bbtext && timeDifference(nextMessage.timestamp,msgList.timestamp)){
          msgList["indexValue"] = index;
          groupmessage.push(msgList);
        lastArray = lastArray.concat(groupmessage);
        //console.log(groupmessage,"groupmessage22222")
        groupmessage = [];
      }else  if(nextMessage!==-1 && messageBody?.messageType===nextMessage?.message?.messageType && atest
        && msgList.direction!==nextMessage?.direction){
          msgList["indexValue"] = index;
          groupmessage.push(msgList);
          lastArray = lastArray.concat(groupmessage);
          groupmessage = [];
      }else if(nextMessage!==-1 && messageBody?.messageType!==nextMessage?.message?.messageType  && atest
        && msgList.direction!==nextMessage?.direction){
          msgList["indexValue"] = index;
          groupmessage.push(msgList);
          lastArray =lastArray.concat(groupmessage);
          groupmessage = [];
      }else if(nextMessage===-1){
        msgList["indexValue"] = index;
        groupmessage.push(msgList);
        lastArray =lastArray.concat(groupmessage);
        groupmessage = [];
      } else if(nextMessage?.message?.body?.text !==messageBody?.body?.text) {
        msgList["indexValue"] = index;
        groupmessage.push(msgList);
        lastArray =lastArray.concat(groupmessage);
        groupmessage = [];
      }else {
        msgList["indexValue"] = index;
        groupmessage.push(msgList);
        lastArray =lastArray.concat(groupmessage);
        groupmessage = [];
      }
  
    }catch(e){
      return <>Something Went Wrong</>;
    }
    try{

    if(Array.isArray(lastArray) && lastArray.length>0){
      //const absValue1 = nextMessage?.timestamp !== undefined && msgList.direction===nextMessage?.direction ?Math.abs(nextMessage?.timestamp - msgList?.timestamp) / (1000 * 60): 16;
    
      let secondArray = [];
      secondArray= lastArray;
      lastArray = [];
      let replyarr = _.filter(secondArray, function(o) { return o?.message?.isReply === true });
      //  let test = elem.contacts.splice(raree, elem.contacts?.length);
    
      if(replyarr?.length >0){
        let tarr = _.filter(secondArray, function(o) { return o?.id !== replyarr[0].id });
        let ttarr = _.findIndex(tarr, function(o) { return o?.message?.body?.text !== "" });
        var p1 = tarr.slice(ttarr+1,tarr.length);
        var p2 = tarr[ttarr] !== undefined?[tarr[ttarr]]:[];
        var p3 = tarr.slice(0,ttarr);
        var p4:any = ttarr === -1? [tarr]: [p3,p2,p1]
  
       
       
        return(<>
   {newTagMessage?.length >0 && (newTagMessage[0]?.id === msgList?.id) && <div className="dividercross"><div className="dividerLineView">{newTagMessage.length>0?newTagMessage.length:''} {unreadmsgcount}</div></div>}
     <ChatReplyMessage  key={index} data={replyarr[0]} groupdata={secondArray} savedData={savedData} searchedData={searchedData} timeValue={index === 0 ? 18:1}/> 
     {p4 && p4.map((msgArrList: any, index: any) => {
    return(<>
      <ChatFilesMessage key={index} groupdata={msgArrList} searchedData={searchedData}
          data={msgArrList}  savedData={savedData} timeValue={index === 0 ? 18:1}/> 
      </>)
     })}
         {/* <ChatFilesMessage key={index} groupdata={tarr} searchedData={searchedData}
          data={tarr}  savedData={savedData} timeValue={index === 0 ? 18:1}/> */}
        </>)

      } else if(secondArray && secondArray?.length > 103) {
       //Greater than 103 images that code execute
        let splitImgArr = _.chunk(secondArray, 102);
        return(<>
        {splitImgArr && splitImgArr.map((msgArrList: any, index: any) => {
          return(<>
          {newTagMessage?.length >0 && (newTagMessage[0]?.id === msgList?.id) && <div className="dividercross"><div className="dividerLineView">{newTagMessage.length>0?newTagMessage.length:''} {unreadmsgcount}</div></div>}
            <ChatFilesMessage key={index} groupdata={msgArrList} searchedData={searchedData}
                data={msgArrList}  savedData={savedData} timeValue={index === 0 ? 18:1}/> 
            </>)
           })}
           </>)
       } else {
        let sarry:any = secondArray;
        let rar = _.findIndex(elem.contacts, function(o:any) {
          return o.id === sarry[0].id
         });
        let previousMessage  = elem.contacts[rar + 1];
        let timeRes:any = previousMessage?.message?.isReply ? 18 : index === 0 ? 18:1 
          return(<>
          {newTagMessage?.length >0 && (newTagMessage[0]?.id === msgList?.id) && <div className="dividercross"><div className="dividerLineView">{newTagMessage.length>0?newTagMessage.length:''} {unreadmsgcount}</div></div>}
          <ChatFilesMessage key={index} groupdata={secondArray} searchedData={searchedData}
            data={secondArray}  savedData={savedData} timeValue={timeRes}/></>)
        }
     
    }
    }
    catch(e){
      console.log(e,"Something went wrong")
      return <>Something Went Wrong</>;
    }
    //Please Don't remove the code it's Reply thread concept
  //letter = elem.letter;
// } else if(messageBody?.isReply ){
  // if(messageBody?.threadId === nextMessage?.message?.threadId 
  //   ){
  //     replyArray.push(msgList);
  // }else if(nextMessage!==-1 && messageBody?.threadId!==nextMessage?.message?.threadId ){
   
  //   replyArray.push(msgList);
  //   lastReplyArray =lastReplyArray.concat(replyArray);
  //   replyArray = [];
   
  // } else if(nextMessage===-1){
  //   replyArray.push(msgList);
  //   lastReplyArray =lastReplyArray.concat(replyArray);
  //   replyArray = [];
  // }  else {
  // }

  // if(Array.isArray(lastReplyArray) && lastReplyArray.length>0){
  //   let secondArray = [];
  //   secondArray= lastReplyArray.reverse();
  //   lastReplyArray = [];
  //   return(<ChatReplyMessage  key={index} data={msgList} groupdata={secondArray}  savedData={savedData} searchedData={searchedData}/>)
  // }
  

 }  else {
  let formArray:any = [];
  formArray.push(msgList)
  let rarId = _.findIndex(elem.contacts, function(o:any) {
    return o.id === msgList.id
   });
 // const absValue = nextMessage?.timestamp !== undefined && msgList.direction===nextMessage?.direction ?Math.abs(nextMessage?.timestamp - msgList?.timestamp) / (1000 * 60) : 16;
 let preMessage  = elem.contacts[rarId!==0 ?rarId - 1:rarId];
 const absValue = index === 0? 18: preMessage?.message?.messageType === "BROADCAST" ? 18:1;
 try{
  return (<>
  {newTagMessage?.length >0 && (newTagMessage[0]?.id === msgList?.id) && <div className="dividercross"><div className="dividerLineView">{newTagMessage.length>0?newTagMessage.length:''} {unreadmsgcount}</div></div>}
  {!messageBody?.isReply && (!messageBody?.isDelete || messageBody?.isDelete?.all !== 1)  && messageBody?.messageType==="TEXT"  ?(
  <> <ChatTextMessage data={msgList} searchedData={searchedData} key={index} savedData={savedData} previousItem="" timeValue={absValue} /></> ) :
 (messageBody?.messageType === "BROADCAST") ? 
 <URBroadcastMessage data={msgList} keyRes={index} key={index}/>
:(!messageBody?.isReply && messageBody?.messageType === "AT_MENTION")?
<ChatMentionMessage  key={index} data={msgList}  searchedData={searchedData} savedData={savedData} timeValue={absValue}/>
:(messageBody?.isReply && messageBody?.messageType !== "IMAGE"  && messageBody?.isDelete?.all !== 1 && !messageBody?.isDeleted  )?
<ChatReplyMessage  key={index} data={msgList} groupdata={lastReplyArray} savedData={savedData} searchedData={searchedData} timeValue={absValue}/>:
(!messageBody?.isReply && messageBody?.isDelete?.all !== 1 && !messageBody?.isDeleted &&  messageBody?.messageType==="NOTE")?
<ChatNotesMessage  key={index} data={msgList} searchedData={chatWindow.searchData}
viewData={searchedData} savedData={savedData} timeValue={absValue}/>:
(!messageBody?.isReply && messageBody?.isDelete?.all !== 1 && !messageBody?.isDeleted &&  messageBody?.messageType==="TASK")?
<ChatTaskMessage  key={index} data={msgList} searchedData={searchedData} viewData={searchedData} savedData={savedData} timeValue={absValue}/>:
(!messageBody?.isReply && messageBody?.isDelete?.all !== 1 && !messageBody?.isDeleted &&  messageBody?.messageType==="EVENTS")?
<URChatEventsMessage  key={index} data={msgList}
            searchedData={chatWindow.searchData}
            viewData={searchedData} savedData={savedData} timeValue={absValue}/>:
((messageBody?.isDelete?.all === 1 || messageBody?.isDeleted) )?  <ChatDeletedMessage  key={index} data={msgList} timeValue={absValue}/>: 
(messageBody?.messageType === "GEO") ?  <>
<ChatMapLocation data={msgList} searchedData={searchedData} key={index} savedData={savedData} previousItem="" /></>
: (messageBody.body?.isCloudfiles && (messageBody?.messageType === "FILE" || messageBody?.messageType === "IMAGE") && !messageBody?.isReply  )  ?
<CloudImageDis key={index} groupdata={formArray} searchedData={searchedData}
  data={formArray}  savedData={savedData} timeValue={index === 0 ? 18:1}/>
   :
   (messageBody?.isReply && messageBody?.messageType === "IMAGE"  && messageBody?.isDelete?.all !== 1 && !messageBody?.isDeleted && messageBody.body?.isCloudfiles  )?
<ChatReplyMessage  key={index} data={msgList} groupdata={lastReplyArray} savedData={savedData} searchedData={searchedData} timeValue={absValue}/>:

null}
  </>)


} catch(e){
 return <>Something went wrong</>
}
}
})}  

            </div>
                </>)
            }

      })}
 {/* <div>
 <Divider plain className="dividerDate">{getGroupDateFormat(elem.letter)}</Divider> 
</div> */}
</div>
        </>
          );
            })}

{((Array.isArray(chatSocketMessage?.messageList) && chatSocketMessage?.messageList.length===0 && !chatSocketMessage?.messageLoading)) && (!isNewMessageWindow)  && <ChatEmpty />}
{((Array.isArray(chatSocketMessage?.messageList) && chatSocketMessage?.messageList.length===0 && !chatSocketMessage?.messageLoading)) && isNewMessageWindow && Array.isArray(newUserMembers) && newUserMembers.length > 0 && <ChatEmpty />}

    </>
  );
};
export default React.memo(ChatInnerFrame)